export default __webpack_public_path__ + "static/media/no-nutrition.c3b74612.svg";